import { isRenterQualifiedForListing } from 'common/householdApplication/prequalificationHelpers';
import {
  LISTING_DATA_SOURCE_REALSAVVY,
  LISTING_DATA_SOURCE_SMART_APARTMENT,
} from 'common/listingConstants';
import { USER_ROLE_ANONYMOUS, USER_ROLE_LIMITED_TOURS } from 'common/userRoles';

export function getListingContactPhone({
  currentUser,
  renterProfilesByUserId,
  listing,
  tenantScreeningCriteriaByPartner,
  tenantScreeningCriteriaByListingId,
  assignedApartmentLocator,
}) {
  const renterProfile = (renterProfilesByUserId && renterProfilesByUserId[currentUser?.id]) || null;
  const tenantScreeningCriteria =
    (tenantScreeningCriteriaByListingId && tenantScreeningCriteriaByListingId[listing?.id]) ||
    (tenantScreeningCriteriaByPartner &&
      tenantScreeningCriteriaByPartner[listing?.listingManagementCompany]);
  const isQualified =
    listing && renterProfile
      ? isRenterQualifiedForListing(renterProfile, listing, tenantScreeningCriteria)
      : true;
  const userAssignedCustomerSupportPhone = currentUser?.customerSupportPhone;
  const currentUserRoles = currentUser?.roles || [];
  const listingAgentCellPhone = listing?.listingAgentCellPhone;

  if (listing?.dataSource === LISTING_DATA_SOURCE_REALSAVVY) {
    return listingAgentCellPhone || listing?.managementCompanyPhone;
  }

  if (listing?.dataSource === LISTING_DATA_SOURCE_SMART_APARTMENT) {
    return assignedApartmentLocator?.secondaryPhone || listing?.apartmentPhone;
  }

  if (
    listingAgentCellPhone &&
    (currentUserRoles.includes(USER_ROLE_ANONYMOUS) ||
      currentUserRoles.includes(USER_ROLE_LIMITED_TOURS) ||
      isQualified === false)
  ) {
    return listingAgentCellPhone;
  }

  return userAssignedCustomerSupportPhone;
}
